"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Avatar = Avatar;
const jsx_runtime_1 = require("react/jsx-runtime");
const class_variance_authority_1 = require("class-variance-authority");
const utilities_1 = require("../../utilities");
const AvatarVariants = (0, class_variance_authority_1.cva)("ko:relative ko:flex ko:items-center ko:justify-center ko:overflow-hidden ko:shrink-0", {
    variants: {
        size: {
            small: "ko:h-10 ko:w-10",
            medium: "ko:h-14 ko:w-14",
            large: "ko:h-20 ko:w-20",
        },
        shape: {
            circle: "ko:rounded-full",
            square: "ko:rounded-2xl",
        },
    },
    defaultVariants: {
        size: "medium",
    },
});
function getSmallestImageUrl(imageUrls) {
    return imageUrls.xs || imageUrls.sm || imageUrls.md || imageUrls.original;
}
function buildSrcSet(imageUrls) {
    const entries = [];
    if (imageUrls.xs)
        entries.push(`${imageUrls.xs} 100w`);
    if (imageUrls.sm)
        entries.push(`${imageUrls.sm} 200w`);
    if (imageUrls.md)
        entries.push(`${imageUrls.md} 400w`);
    return entries.join(", ");
}
function Avatar({ image, backgroundColor, shape, alignment = "center", padding = false, fit = "cover", size, className }) {
    const sizeMap = {
        small: "40px",
        medium: "56px",
        large: "80px",
    };
    const sizesAttr = sizeMap[size || "medium"];
    const alignmentClass = alignment === "top" ? "ko:object-top" : "ko:object-center";
    const paddingClass = padding ? "ko:p-2" : "";
    const fitClass = fit === "contain" ? "ko:object-contain" : "ko:object-cover";
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, utilities_1.twMerge)(AvatarVariants({ size, shape }), paddingClass, className), children: [backgroundColor && (0, jsx_runtime_1.jsx)("div", { className: "ko:absolute ko:inset-0", style: { backgroundColor } }), (0, jsx_runtime_1.jsx)("img", { src: getSmallestImageUrl(image), srcSet: buildSrcSet(image), sizes: sizesAttr, alt: "", loading: "lazy", className: `ko:relative ko:z-10 ko:h-full ko:w-full ${fitClass} ${alignmentClass}` })] }));
}
